import { forwardRef } from "react";
import type { Meeting } from "@acto/taskpane/core/domain";
import { useCustomerById } from "@acto/taskpane/core/data-access/customers/useCustomerById";
import { CustomerCard } from "@acto/taskpane/field-sales-2/components/patterns/CustomerCard";

interface FrontCardProps {
  meeting: Meeting;
  hideDate?: boolean;
  showBadgeTime?: boolean;
  expanded?: boolean;
  onToggleExpand?: () => void;
}

// Wraps the front CustomerCard and eagerly fetches the rich client (tags + detail
// fields), independent of `expanded`, so expanding shows full content with no height
// jump. The fetch is cache-first; only the front card mounts this, so behind cards
// (blank CardSurface placeholders) never fetch. Forwards the ref through to the card's
// root element, which the deck morph animation depends on.
export const FrontCard = forwardRef<HTMLElement, FrontCardProps>(function FrontCard(
  { meeting, hideDate, showBadgeTime, expanded, onToggleExpand },
  ref,
) {
  const { data } = useCustomerById(meeting.customer.id);

  return (
    <CustomerCard
      ref={ref}
      meeting={meeting}
      hideDate={hideDate}
      showBadgeTime={showBadgeTime}
      detailCustomer={data}
      expanded={expanded}
      onToggleExpand={onToggleExpand}
    />
  );
});
